import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';
import { useState } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      const response = await fetch('https://readdy.ai/api/form/d60ulobn6d2i4h4oa1u0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData).toString()
      });
      
      if (response.ok) {
        setSubmitStatus('Thank you! Your message has been sent successfully.');
        setFormData({ name: '', email: '', phone: '', company: '', message: '' });
      } else {
        setSubmitStatus('Sorry, there was an error sending your message. Please try again.');
      }
    } catch (error) {
      setSubmitStatus('Sorry, there was an error sending your message. Please try again.');
    }
    
    setIsSubmitting(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 to-teal-50">
      <Navigation />
      
      {/* Hero Section */}
      <section className="pt-20 md:pt-24 pb-10 md:pb-16 px-4 md:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-3xl md:text-6xl font-bold text-gray-800 mb-4 md:mb-6">견적 문의</h1>
          <p className="text-base md:text-2xl text-gray-600 mb-6 md:mb-8 px-2">
            <span className="block">프로젝트에 대한 문의사항이 있으시면 언제든지 연락주세요.</span>
            <span className="block">전문 상담을 통해 최적의 솔루션을 제안해 드립니다.</span>
          </p>
        </div>
      </section>
      
      {/* Contact Form & Info */}
      <section className="pb-10 md:pb-16 px-4 md:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-8 md:gap-12">
            {/* Contact Form */}
            <div className="bg-white rounded-2xl p-5 md:p-8 shadow-lg">
              <h2 className="text-xl md:text-3xl font-bold text-gray-800 mb-4 md:mb-6">견적 문의하기</h2>
              
              <form id="contact-form" data-readdy-form onSubmit={handleSubmit} className="space-y-4 md:space-y-6">
                <div>
                  <label htmlFor="name" className="block text-xs md:text-sm font-medium text-gray-700 mb-1.5 md:mb-2">
                    이름*
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    className="w-full px-3 md:px-4 py-2.5 md:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-400 focus:border-transparent text-sm"
                    placeholder="Enter your full name"
                  />
                </div>
                
                <div>
                  <label htmlFor="email" className="block text-xs md:text-sm font-medium text-gray-700 mb-1.5 md:mb-2">
                    이메일*
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    className="w-full px-3 md:px-4 py-2.5 md:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-400 focus:border-transparent text-sm"
                    placeholder="your.email@example.com"
                  />
                </div>
                
                <div>
                  <label htmlFor="phone" className="block text-xs md:text-sm font-medium text-gray-700 mb-1.5 md:mb-2">
                    연락처*
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    required
                    className="w-full px-3 md:px-4 py-2.5 md:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-400 focus:border-transparent text-sm"
                    placeholder="010-0000-0000"
                  />
                </div>
                
                <div>
                  <label htmlFor="company" className="block text-xs md:text-sm font-medium text-gray-700 mb-1.5 md:mb-2">
                    회사명*
                  </label>
                  <input
                    type="text"
                    id="company"
                    name="company"
                    value={formData.company}
                    onChange={handleInputChange}
                    required
                    className="w-full px-3 md:px-4 py-2.5 md:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-400 focus:border-transparent text-sm"
                    placeholder="회사명을 입력해주세요"
                  />
                </div>
                
                <div>
                  <label htmlFor="message" className="block text-xs md:text-sm font-medium text-gray-700 mb-1.5 md:mb-2">
                    문의 내용
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    required
                    maxLength={500}
                    rows={4}
                    className="w-full px-3 md:px-4 py-2.5 md:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-400 focus:border-transparent text-sm resize-none"
                    placeholder="Tell me about your project or question..."
                  ></textarea>
                  <p className="text-xs text-gray-500 mt-1">
                    {formData.message.length}/500 characters
                  </p>
                </div>
                
                <Button 
                  type="submit" 
                  variant="primary" 
                  size="lg" 
                  className="w-full"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Sending...' : '문의 하기'}
                </Button>
                
                {submitStatus && (
                  <div className={`p-3 md:p-4 rounded-lg text-center text-sm md:text-base ${
                    submitStatus.includes('Thank you') 
                      ? 'bg-green-100 text-green-700' 
                      : 'bg-red-100 text-red-700'
                  }`}>
                    {submitStatus}
                  </div>
                )}
              </form>
            </div>
            
            {/* Contact Info */}
            <div className="space-y-6 md:space-y-8">
              <div className="bg-white rounded-2xl p-5 md:p-8 shadow-lg">
                <h3 className="text-lg md:text-2xl font-bold text-gray-800 mb-4 md:mb-6">연락처 정보</h3>
                
                <div className="space-y-4 md:space-y-6">
                  <div className="flex items-start gap-3 md:gap-4">
                    <div className="w-10 h-10 md:w-12 md:h-12 bg-emerald-500 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-mail-fill text-white text-base md:text-xl"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-800 text-sm md:text-base">이메일 문의</h4>
                      <p className="text-gray-600 text-sm md:text-base">steng2021@naver.com</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start gap-3 md:gap-4">
                    <div className="w-10 h-10 md:w-12 md:h-12 bg-teal-500 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-phone-fill text-white text-base md:text-xl"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-800 text-sm md:text-base">전화 문의</h4>
                      <p className="text-gray-600 text-sm md:text-base">031) 989-7136</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start gap-3 md:gap-4">
                    <div className="w-10 h-10 md:w-12 md:h-12 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-map-pin-fill text-white text-base md:text-xl"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-800 text-sm md:text-base">주소(위치 정보)</h4>
                      <p className="text-gray-600 text-sm md:text-base">경기도 김포시 대곶면 쇄암로 144</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* FAQ Section */}
      <section className="py-10 md:py-16 px-4 md:px-8 bg-white">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-2xl md:text-4xl font-bold text-center text-gray-800 mb-8 md:mb-12">자주하는 질문(문의 사항)</h2>
          
          <div className="space-y-4 md:space-y-6">
            <div className="bg-gray-50 rounded-2xl p-4 md:p-6">
              <h3 className="text-lg md:text-xl font-bold text-gray-800 mb-2">어떤 제품/시설물을 취급하나요?</h3>
              <p className="text-base md:text-lg text-gray-600">
                공원, 외부 공간에 적용되는 시설물을 중심으로<br />
                파고라, 벤치, 운동기구, 안내판 등의 다양한 공원 시설물을 제작 및 공급합니다.
              </p>
            </div>
            
            <div className="bg-gray-50 rounded-2xl p-4 md:p-6">
              <h3 className="text-lg md:text-xl font-bold text-gray-800 mb-2">제작만 가능한가요? 설치까지도 가능한가요?</h3>
              <p className="text-base md:text-lg text-gray-600">
                네. 제작부터 현장 설치까지 프로젝트 범위에 맞춰 진행합니다. 현장 조건에 따라 설치 방식 및 공정을 제안드립니다.
              </p>
            </div>
            
            <div className="bg-gray-50 rounded-2xl p-4 md:p-6">
              <h3 className="text-lg md:text-xl font-bold text-gray-800 mb-2">주문 제작(맞춤 디자인)도 가능한가요?</h3>
              <p className="text-base md:text-lg text-gray-600">
                네. 디자인 시안을 제작을 통해 맞춤 설계 및 제작이 가능하며 그에 따른 제품을 지원합니다.
              </p>
            </div>
            
            <div className="bg-gray-50 rounded-2xl p-4 md:p-6">
              <h3 className="text-lg md:text-xl font-bold text-gray-800 mb-2">제작/납기는 보통 얼마나 걸리나요?</h3>
              <p className="text-base md:text-lg text-gray-600">
                제품 종류와 수량, 맞춤 여부에 따라 달라집니다. 표준 제품은 기간이 짧고 맞춤 제작의 경우 제작 기간이 추가됩니다.
              </p>
            </div>
            
            <div className="bg-gray-50 rounded-2xl p-4 md:p-6">
              <h3 className="text-lg md:text-xl font-bold text-gray-800 mb-2">제품 납품 후 A/S는 어떻게 진행되나요?</h3>
              <p className="text-base md:text-lg text-gray-600">
                설치 후 발생하는 문제에 대해 상황 확인 후 점검 및 조치를 진행하며,<br />
                제품 상태와 사용 환경에 따라 적절한 대응 방안을 안내드립니다.
              </p>
            </div>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
}
